import {
  ATDividedList,
  ATDividedListItem,
} from 'components/common/beacon/beaconRegistration';
import React from 'react';
import { Orientations } from '@trp-beacon-ui-kit/foundation/dist/_common/types/orientations';
import { IInternalAccount } from '../../../../api/internal/internalApi.types';

interface AccountDetailsProps {
  account: IInternalAccount;
}

const AccountDetails: React.FC<AccountDetailsProps> = ({ account }) => (
  <div
    data-testid="internal-accounts"
    className="external-account b-grid b-padding--micro--jumbo custom-style"
  >
    <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:12-col b-lg:12-col">
      <ATDividedList className="data-list" orientation={Orientations.Vertical}>
        <ATDividedListItem>
          <span slot="supporting-text">Account number</span>
          <span slot="data-point">{account.agreementNumber ?? ''}</span>
        </ATDividedListItem>
        <ATDividedListItem>
          <span slot="supporting-text">Owner(s)</span>
          <span slot="data-point">{account.ownerNames?.join(', ') ?? ''}</span>
        </ATDividedListItem>
      </ATDividedList>
    </div>
  </div>
);

export default AccountDetails;
